export class AcceptError extends Error {
    constructor(public readonly supportId: number, private readonly errorMessage?: string) {
        let message = `Error while accepting support by id ${supportId}`;
        if (errorMessage) {
            message += `\n\r ${errorMessage}`;
        }
        super(message);
    }
}